module.exports = __webpack_public_path__ + "img/TIMES.b8db1b45.svg";